import ApiService from "@/common/api.service"

export const TrainingSummaryService = {
    getTrainingSummary() {
        return ApiService.get("/trainingReport")
    },
    getCat2TrainingSummary() {
        return ApiService.get("/trainingCat2Report")
    },
    async getNewTraineeAssignList(params) {
        const res = await ApiService.get(`/trainingUpdate/new-trainee-assigns${params}`);
        return res.data;
    },
    async getTrainingCentersDrp() {
        const res = await ApiService.get("/trainingCenters/drp");
        return res.data;
    },
    async getAnnualCeuSummary(params) {
        const res = await ApiService.get(`/trainingUpdate/new-trainee-assigns/ceu-summary${params}`);
        return res.data;
    },

}
